import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { ContactsManager } from "@/components/app/contacts-manager";

export const Route = createFileRoute("/_authenticated/contacts")({
  head: () => ({
    meta: [
      { title: "Contacts | Warrior Volunteer" },
      {
        name: "description",
        content: "See and manage every outreach contact you own in one place.",
      },
      { property: "og:title", content: "Contacts | Warrior Volunteer" },
      {
        property: "og:description",
        content: "See and manage every outreach contact you own in one place.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ContactsPage,
});

function ContactsPage() {
  return (
    <AppShell eyebrow="Inbox" title="Contacts">
      <ContactsManager scope="mine" />
    </AppShell>
  );
}
